import { render, staticRenderFns } from "./_tab.vue?vue&type=template&id=1b117b9c"
import script from "./_tab.vue?vue&type=script&lang=js"
export * from "./_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports